<template>
  <div class="n_continer">
    <van-tabs v-model="active" sticky animated @click="openclickFg">
      <van-tab :title="i" v-for="i in tabs" :key="i">
        <div class="n_contents">
          <van-list v-model="loading" :finished="finished" finishedText="没有更多了" @load="onLoad">
            <div class="n_list">
              <div class="n_card" v-for="i in list" :key="i.id">
                <div class="n_title">{{'ID:' + i.id + '-'}}{{i.title}}</div>
                <div class="n_name n_mtop">提货卡：{{i.plus_score}}</div>
                <div class="n_num n_name n_yihang" v-for="item in i.detail_list" :key="item.id">
                  <block v-if="item.plus_num > 0">{{item.goods_name}}：{{item.plus_num}}瓶</block>
                </div>
                <div class="n_tips" v-if="i.status == 2 || active == 1 || active == 2">
                  <!-- 已使用未过期 -->
                  <div class="n_tipstxt" v-if="active == 1">已使用</div>
                  <div class="n_tipstxt" v-if="active == 2">已过期</div>
                  <div class="n_tipstxt flex n_cancel" v-if="i.status == 2">
                    已赠送 未领取
                    <div class="n_btn n_canbtn" @click="transFireFg(i)">回收</div>
                  </div>
                </div>
                <div class="n_time n_num">有效期：{{i.end_time}}</div>
                <div class="n_btns">
                  <div></div>
                  <div class="flex">
                    <div class="n_btn n_red" @click="jump('./giftGoodsCont')">提货</div>
                    <!-- 合伙人显示 -->
                    <div class="n_btn n_text" @click="goZen(i)" v-if="is_partner == 1">转让</div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
    <van-overlay :show="show" @click.stop="show = false" z-index="99">
      <div class="n_photo" @click.stop="noparams">
        <input
          class="n_input"
          @focus="focusFg"
          v-model="receive_mobile"
          type="number"
          placeholder="请输入接收人手机号码"
        />
        <input
          class="n_input"
          @focus="focusFg"
          v-model="rec_member_id"
          type="number"
          placeholder="请输入推荐人用户ID"
        />
        <a class="tiop_cont" @click="isImg = true">如何获取推荐人ID?</a>
        <p class="n_tipsCont">注意：仅该手机号用户可领取</p>
        <!-- 合伙人显示 -->
        <div class="n_button" @click.stop="transferPackageOrderFg">转让</div>
      </div>
    </van-overlay>
    <van-share-sheet
      :overlay="false"
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <van-overlay :show="isShow" @click.stop="isShow = false">
      <div class="n_cardshare">
        <img :src="posterUrl" alt />
      </div>
    </van-overlay>
    <van-overlay :show="isCard">
      <div class="n_photos" @click.stop="noparams">
        <div class="n_tihuo">
          <div class="flex nm_juspace">
            <div></div>
            <div class="n_cardprice">
              {{cardInfo.plus_score}}
              <!-- <p class="n_yuan">元</p> -->
            </div>
          </div>
          <div class="n_footertxt" v-if="cardInfo.detail_list">
            <p>卡内含</p>
            <div v-for="i in cardInfo.detail_list" :key="i.id" class="flex">
              {{cardInfo.plus_score}}元&nbsp;&nbsp;
              <p class="n_linenone">{{i.goods_name}}</p>
              *&nbsp;&nbsp;{{i.plus_num}}
            </div>
            <p>{{cardInfo.plus_score}}元&nbsp;&nbsp;十大酒水提货额度</p>
          </div>
        </div>
        <div class="flex nm_juspace">
          <div class="n_buttons" @click.stop="reciverCard">确定领取</div>
        </div>
        <a class="n_comine" @click="jump('./home')">暂不领取返回首页</a>
      </div>
    </van-overlay>
    <van-action-sheet v-model="isPhone" title="请您绑定手机号~~" :closeable="false">
      <div class="n_content">
        <van-field v-model="formData.mobile" placeholder="请输入手机号" type="tel" label="手机号" />
        <van-field v-model="formData.code" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button
              size="small"
              type="primary"
              class="n_buttonss"
              @click="smsSend"
            >{{sign == false ? '发送验证码' : codehtml + 'S'}}</van-button>
          </template>
        </van-field>
        <div class="what">
          <div class="sc" style="background:#EDEDED;color:#0CC060" @click="show = false">暂不绑定</div>
          <div class="sc" style="background:#0CC060;color:#fff" @click="land">立即绑定</div>
        </div>
      </div>
    </van-action-sheet>
    <van-dialog v-model="isImg">
      <img class="tips_imgs" src="../assets/img/tips.png" />
    </van-dialog>
  </div>
</template>

<script>
import share from '../public/share.js'
import masterPath from '../../config.js'
import { Toast, Dialog } from 'vant'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      tabs: ['可用提货卡', '已使用', '已过期'],
      page: 0,
      active: 0,
      show: false,
      isImg: false,
      showShare: false,
      options: [
        { name: '微信', icon: 'wechat' },
        { name: '图卡', icon: 'poster' },
      ],
      isShow: false,
      cur: {},
      receive_mobile: '',
      isCard: false,
      cardInfo: {}, //收到的礼包
      transfer_order_sn: '',
      posterUrl: '',
      isPhone: false,
      formData: {},
      codehtml: 60, //倒计时秒
      sign: false, //倒计时
      is_partner: 0,
      rec_member_id: '',
      specId: '',
      typeId: '',
    }
  },
  created() {
    this.getStringFg(window.location.href)
    this.is_partner = localStorage.getItem('is_partner')
  },
  watch: {
    '$store.state.shareStr': function (e) {
      if (e == 'delivery') {
        this.shareModelFg()
      }
    },
  },
  methods: {
    checkOfflineGift() {
      this.http('ClientOrder.checkOfflineGift', { id: this.specId }).then(
        (res) => {
          if (res.status == 200) {
            if (res.content.order_no != '') {
              let params = {
                token: localStorage.getItem('token'),
                mechId: localStorage.getItem('mechId'),
                sn: res.content.order_no,
                transfer_ids: 1,
                type: 'receive_package',
              }
              let str = ''
              for (let i in params) {
                str += `${i}=${params[i]}&`
              }
              str = str.slice(0, str.length - 1)
              window.location.href = `${
                masterPath.masterPay
              }/cashierDesk?${encodeURIComponent(str)}`
            } else {
              this.isCard = true
            }
          } else {
            Toast(res.msg)
          }
          // receive_package  名额场景值
          // localStorage.getItem('spec_id') 领取券标识
        }
      )
    },
    shareModelFg() {
      let uid
      if (localStorage.getItem('userInfo')) {
        uid = JSON.parse(localStorage.getItem('userInfo')).id
      } else {
        return
      }
      let url =
        window.location.href.split('?')[0] +
        '?type=share' +
        '&uid=' +
        uid +
        '&scenes=packages' +
        '&packgId=' +
        this.cur.id

      wx.showMenuItems({
        menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
      })

      let shareInfo = {
        title: '送给您一张提货卡',
        desc: '登录后，输入手机号即可领取',
        link: url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
        imgUrl:
          'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_liaotianka.png',
      }
      wx.onMenuShareAppMessage(shareInfo)
      wx.onMenuShareTimeline(shareInfo)
    },
    focusFg() {
      this.showShare = false
      console.log('11')
    },
    smsSend() {
      if (!/^[1][0-9]{10}$/.test(this.formData.mobile)) {
        Toast('手机号码有误，请重填')
        return false
      }
      if (this.sign) return
      //获取验证码
      let { mobile, code, verifyCode } = this.formData
      this.http('Base.smsSend', { mobile: mobile }).then((res) => {
        if (res.status == 200) {
          console.log(res, '3333333')
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          this.time = tim
        } else {
          Toast(res.msg)
        }
      })
    },
    //登陆按钮
    land(e) {
      if (this.formData.mobile == '') {
        Toast('请先输入手机号')
        return
      }
      if (this.formData.code == '') {
        Toast('请先输入验证码')
        return
      }
      let flag = false
      if (flag) return
      flag = true
      let { mobile, code, verifyCode } = this.formData
      this.http('Client.signUp', this.formData).then((res) => {
        if (res.status == 200) {
          if (this.specId && this.specId != '') {
            this.checkOfflineGift()
          } else {
            this.getAwaierList()
          }
          console.log(res, 'response.data.content')
          this.$store.commit('increment', '成功')
          let contentListy = JSON.parse(localStorage.getItem('userInfo'))
          contentListy.mobile = res.content.mobile
          contentListy = JSON.stringify(contentListy)
          localStorage.setItem('userInfo', contentListy)
          this.isPhone = false
          flag = false
        } else {
          this.$store.commit('increment', res.msg)
          flag = false
        }
      })
    },
    //领取礼包卡
    async reciverCard() {
      if (this.specId && this.specId != '') {
        this.$router.replace({
          path: './giftBig',
          query: { id: this.specId, typeId: this.typeId },
        })
      } else {
        let res = await this.http('ClientOrder.receiveTransfer', {
          transfer_id: this.cardInfo.id,
        })
        if (res.status == 200) {
          Toast('领取成功')
          this.$router.push({ path: './home' })
        } else {
          Notify({ type: 'danger', message: res.msg })
          // Toast(res.msg)
        }
      }
    },
    //获取赠送的礼包
    async getAwaierList() {
      let res = await this.http('ClientOrder.getAwaitReceiveTransfer', {
        limit: 1,
      })
      if (res.content.id) {
        this.isCard = true
      }
      this.cardInfo = res.content
    },
    //分享关系
    async shareExtensionFg(obj) {
      let res = await this.http('Client.shareExtension', {
        share_member_id: obj.uid,
        share_staff_id: obj.share_staff_id || 0,
        scenes: obj.scenes,
        extend_id: obj.packgId,
      })
      localStorage.setItem('shareId', res.content.share_sign_no)
      // 查看是否有红包
      if (res.content.share_sign_no) {
        this.receiveShareRedPacket(res.content.share_sign_no)
      }
    },
    // 领取分享新用户得红包  有分享关系请求
    receiveShareRedPacket(id) {
      this.http('MemberRedPacket.receiveShareRedPacket', {
        share_sign_no: id,
      }).then((e) => {
        console.log(e)
      })
    },
    //获取url字符串
    getStringFg(url) {
      let hrr = []
      let obj = {}
      //截取内部参数
      let params = url.substr(url.indexOf('?') + 1)
      //逗号隔开
      let str = params.replace(/\&/g, ',')
      console.log(str)
      let crr = []
      str.split(',').map((i, index) => {
        crr.push(i.replace(/\=/g, ',').split())
      })
      crr.map((item) => {
        item.forEach((i) => {
          hrr.push(i.split(','))
        })
      })
      hrr.map((item) => {
        obj[item[0]] = item[1]
      })
      localStorage.setItem('shareInfo', JSON.stringify(obj))
      if (
        obj.type == 'share' &&
        obj.scenes == 'packages' &&
        JSON.parse(localStorage.getItem('isToken'))
      ) {
        this.shareExtensionFg(obj)
        console.log(JSON.parse(localStorage.getItem('userInfo')))
        if (JSON.parse(localStorage.getItem('userInfo')).mobile == '') {
          console.log('111')
          this.isPhone = true
          return
        }
        this.getAwaierList()
      } else if (obj.type == 'transfer') {
        this.specId = obj.id || ''
        this.typeId = obj.type_id || 0
        if (JSON.parse(localStorage.getItem('userInfo')).mobile == '') {
          console.log('111')
          this.isPhone = true
          return
        } else {
          this.checkOfflineGift()
        }
      } else if (JSON.parse(localStorage.getItem('shareInfo')).uid) {
        this.shareExtensionFg(JSON.parse(localStorage.getItem('shareInfo')))
      }
    },
    noparams() {},
    //输入手机号赠送
    goZen(i) {
      this.cur = i
      this.show = true
    },
    //回收
    transFireFg(i) {
      let _this = this
      Dialog.confirm({
        message: '回收后，用户将无法领取!',
      })
        .then(() => {
          this.http('ClientOrder.transferRevoke', {
            transfer_id: i.id,
          }).then((res) => {
            console.log(res)
            if (res.status == 200) {
              _this.list = []
              _this.active = 0
              _this.page = 1
              _this.getList()
            } else {
              Toast(res.msg)
            }
          })
          // on confirm
        })
        .catch(() => {
          // on cancel
        })
    },
    onSelect(option) {
      let uid
      if (option.name == '微信') {
        Toast('请点击右上角分享给好友')
      } else {
        this.getPickUpPoster()
      }
      console.log(option)
    },
    jump(e) {
      this.$router.push({ path: e })
    },
    openclickFg(t, n) {
      let flag = false
      if (flag) return
      flag = true
      this.active = Number(t)
      this.list = []
      this.page = 1
      this.getList()
      flag = false
      console.log(t, n)
    },
    onLoad() {
      this.page++
      this.getList()
    },
    async getList() {
      let res = await this.http('ClientOrder.getMyTransferList', {
        page: this.page,
        size: 10,
        type: this.active + 1,
      })
      this.list = this.list.concat(res.content.list)
      this.loading = false
      this.finished = this.list.length == res.content.count
      console.log(res)
    },
    //赠送
    async transferPackageOrderFg() {
      let res = await this.http('ClientOrder.transferPackageOrder', {
        transfer_id: this.cur.id,
        receive_mobile: this.receive_mobile,
        rec_member_id: this.rec_member_id,
      })
      if (res.status == 200) {
        this.page = 1
        this.list = []
        this.getList()
        this.transfer_order_sn = res.content.transfer_order_sn
        // let uid
        // if (localStorage.getItem('userInfo')) {
        //   uid = JSON.parse(localStorage.getItem('userInfo')).id
        // } else {
        //   uid = ''
        // }
        // new share({
        //   goods: {
        //     goods_name: '送给您一张提货卡',
        //     images:
        //       'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_liaotianka.png',
        //     content: '登录后，输入手机号即可领取~',
        //   },
        //   url:
        //     window.location.href.split('?')[0] +
        //     '?type=share' +
        //     '&uid=' +
        //     uid +
        //     '&scenes=packages' +
        //     '&packgId=' +
        //     this.cur.id,
        //   startUrl: window.location.href,
        // })

        if (this.$store.state.shareStr != 'delivery') {
          new share(
            {
              startUrl: window.location.href,
            },
            this.$store,
            'delivery'
          )
        } else {
          this.shareModelFg()
        }
        this.showShare = true
      } else {
        Toast(res.msg)
      }
      console.log(res)
    },
    //获取海报
    async getPickUpPoster() {
      let res = await this.http('Client.getPickUpPoster', {
        order_sn: this.transfer_order_sn,
      })
      console.log(res.content)
      if (res.status == 200) {
        this.posterUrl = res.content.url
        console.log(this.posterUrl)
        this.isShow = true
      } else {
        Toast(res.msg)
      }
    },
  },
}
</script>
<style >
.n_continer .van-overlay {
  z-index: 8888;
}
.n_continer .van-toast {
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
.what {
  display: flex;
  justify-content: center;
  padding-top: 50px;
}
.sc {
  border-radius: 5px;
  background: red;
  height: 80px;
  width: 200px;
  text-align: center;
  margin: 0 20px;
  font-size: 24px;
  line-height: 80px;
}
.n_buttonss {
  padding: 5px 10px;
}
.n_linenone {
  width: 300px;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.n_photos {
  position: relative;
  width: 560px;
  // height: 353px;
  background: #ffffff;
  border-radius: 20px;
  margin: 400px auto;
  box-sizing: border-box;
  padding: 38px 30px;
}
.n_tihuo {
  width: 500px;
  min-height: 274px;
  padding: 20px;
  box-sizing: border-box;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_th_card.png')
    no-repeat left top;
  background-size: 100%;
  color: rgba(214, 176, 151, 1);
}
.n_cardprice {
  display: flex;
  align-items: center;
  font-size: 42px;
}
.n_footertxt {
  margin-top: 60px;
  font-size: 24px;
  color: #e7c5af;
}
.n_buttons {
  width: 500px;
  height: 88px;
  line-height: 88px;
  background: #ee0a24;
  border-radius: 30px;
  color: rgba(255, 255, 255, 1);
  font-size: 30px;
  text-align: center;
  margin-top: 30px;
}
.n_comine {
  font-size: 24px;
  color: rgba(255, 255, 255, 1);
  margin-top: 10px;
  text-align: center;
  position: absolute;
  bottom: -60px;
  left: 180px;
}
.nm_juspace {
  justify-content: space-between;
}
.n_yuan {
  font-size: 32px;
}
.n_delivetxt {
  text-align: center;
  padding-top: 34px;
}
.n_color {
  color: rgba(214, 176, 151, 1);
  text-align: center;
}
.n_auto {
  // margin-left: 100px;
}
.n_clasfons {
  font-size: 24px;
}
.n_fuha {
  font-size: 42px;
}
.n_pricenum {
  font-size: 78px;
}
.n_cardshare {
  width: 560px;
  height: 817px;
  background-size: 560px 817px;
  margin: 200px auto 0;
  z-index: 9999;
}
.n_cardshare img {
  width: 100%;
  height: 100%;
}
.n_photo {
  width: 560px;
  height: 520px;
  background: #ffffff;
  border-radius: 20px;
  margin: 400px auto;
  box-sizing: border-box;
  padding: 38px 30px;
  .n_input {
    margin-bottom: 20px;
  }
}
.n_input {
  width: 100%;
  padding: 28px 30px;
  background: #ffffff;
  border-radius: 20px;
  border: 1px solid #dedede;
  box-sizing: border-box;
}
.n_canbtn {
  color: rgba(238, 10, 36, 1);
  background: #ffffff;
  margin-left: 40px;
}
.n_tipsCont {
  font-size: 26px;
  color: #ee0a24;
  margin-left: 30px;
  margin-top: 10px;
}
.tiop_cont {
  font-size: 26px;
  color: #ee0a24;
  margin-left: 30px;
  margin-top: 10px;
}
.n_button {
  width: 500px;
  height: 88px;
  line-height: 88px;
  background: #ee0a24;
  border-radius: 44px;
  color: rgba(255, 255, 255, 1);
  font-size: 30px;
  text-align: center;
  margin-top: 30px;
}
.n_cancel {
  padding-left: 150px;
  align-items: center;
}
.n_continer {
  background: #f7f8fa;
  min-height: 100vh;
  border-radius: 32px;
}
.n_contents {
  padding: 40px;
}
.n_content {
  min-height: 400px;
  box-sizing: border-box;
  padding: 20px 30px;
}
.n_card {
  position: relative;
  height: 100%;
  // background: rgba(255, 255, 255, 1);
  padding: 30px 30px 15px;
  margin-bottom: 20px;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_card2.png')
    no-repeat left top;
  background-size: 100% 100%;
  color: #ffffff !important;
}
.n_tips {
  z-index: 99;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
}
.n_tipstxt {
  font-size: 32px;
  color: #ffffff;
  margin: 140px auto 0;
  text-align: center;
}
.n_title {
  font-size: 32px;
  color: #fff;
}
.n_name {
  font-size: 28px;
  color: #ffff;
}
.n_yihang {
  width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.n_mtop {
  margin-top: 14px;
}
.n_time {
  font-size: 28px;
  color: #fff;
}
.n_num {
  margin-top: 6px;
}
.n_btns {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.n_btn {
  padding: 6px 34px;
  border-radius: 32px;
}
.n_red {
  background: #ee0a24;
  color: rgba(255, 255, 255, 1);
  margin-right: 20px;
}
.n_text {
  color: rgba(238, 10, 36, 1);
  background: #ffffff;
  border-radius: 32px;
  // border: 2px solid #ee0a24;
}
.tips_imgs {
  display: block;
  margin: 0 auto;
  width: 100%;
  // height: 350px;
  padding: 20px 0;
}
</style>